<template>
    <el-dialog title="值域检查结果" width="70%" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <div class="el-table-container">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" ref="multipleTable" border>
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicName" label="元数据名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicName" label="所处位置" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicName" label="排序" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicName" label="元数据类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="组件类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="组件权限" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="是否必填" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="查询条件" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="列表展示" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="描述" show-overflow-tooltip></el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size" @pagination="refreshList"/>
        </div>
        <div slot="footer">
            <el-button size="small" @click="visible = false">返回</el-button>
            <el-button size="small" type="primary" @click="" v-noMoreClick>导出</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                searchForm: {
                    current: 1,
                    size: 20,
                },
                dataList: [],
                total: 0,
            }
        },
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.refreshList(1)
                })
            },
            refreshList(type) {
                if (type == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                this.$axios(this.api.metadata.selectMetadataBasicByAssembly, this.searchForm, 'post').then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    }
                })
            },
        }
    }
</script>

<style scoped>
</style>
